import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SuitcaseTheatreArcadeStyle.css';
import SuitcaseLogo from '../static/images/SuitcaseTheatreArcadeLogo.jpg';

const DONATION_URL = 'https://paypal.me/suitcasearcade';

function Donate() {
    return (
        <main className="donation-page">
            <section className="donation-hero fade-in" aria-labelledby="donation-title">
                <div className="donation-copy">
                    <p className="services-eyebrow">Donations &amp; gratuities</p>
                    <h1 id="donation-title">Support miniature worlds.</h1>
                    <p>
                        Your gratuity helps Suitcase Theatre Arcade keep building portable
                        puppet shows, maintaining materials and sharing small theatrical
                        experiences with audiences in community spaces.
                    </p>
                    <div className="donation-actions">
                        <a
                            className="arcade-button arcade-button-primary"
                            href={DONATION_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Donate with PayPal
                        </a>
                        <Link className="arcade-button arcade-button-secondary" to="/contact">
                            Book a show
                        </Link>
                    </div>
                </div>

                <div className="donation-visual" aria-hidden="true">
                    <img src={SuitcaseLogo} alt="" />
                    <div className="donation-token">
                        <span>Tip</span>
                        <strong>Jar</strong>
                    </div>
                </div>
            </section>

            <section className="donation-card-grid" aria-label="What donations support">
                <article className="donation-card">
                    <h2>Show Materials</h2>
                    <p>
                        Supplies, repairs and tiny scenic details that keep each miniature
                        world ready for its next audience.
                    </p>
                </article>

                <article className="donation-card">
                    <h2>Community Events</h2>
                    <p>
                        Travel, setup time and accessible presentation costs for libraries,
                        festivals, schools and public gatherings.
                    </p>
                </article>

                <article className="donation-card">
                    <h2>Creative Time</h2>
                    <p>
                        Development time for new puppet pieces, experiments and hands-on arts
                        education activities.
                    </p>
                </article>
            </section>
        </main>
    );
}

export default Donate;
